import { useId } from 'react';
import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

/**
 * BigQuery mark (simplified from `static/img/integrations/bigquery/assets/images/square.svg`).
 * Inline SVG so we do not need an `app-icon-bigquery` sprite entry.
 */
export function BigQueryIcon(props: IconProps) {
  const gradientId = `bq-grad-${useId().replace(/:/g, '')}`;

  return (
    <Icon {...props} viewBox="0 0 64 64">
      <path
        d="M14.3456 56.8008L1.54714 34.6324C1.05507 33.7801 0.796021 32.8133 0.796021 31.8292C0.796021 30.8451 1.05507 29.8783 1.54714 29.026L14.3456 6.85806C14.8378 6.00565 15.5456 5.29781 16.398 4.80569C17.2505 4.31358 18.2174 4.05453 19.2017 4.05459H44.7986C45.7828 4.05461 46.7497 4.3137 47.602 4.80581C48.4544 5.29792 49.1622 6.00572 49.6543 6.85806L62.4527 29.026C62.9449 29.8783 63.204 30.8452 63.204 31.8294C63.204 32.8137 62.9449 33.7806 62.4527 34.6329L49.6543 56.8008C49.1621 57.6531 48.4543 58.3608 47.602 58.8528C46.7496 59.3448 45.7828 59.6038 44.7986 59.6038H19.2017C18.2174 59.6039 17.2504 59.3449 16.398 58.8528C15.5456 58.3607 14.8377 57.6533 14.3456 56.8008Z"
        fill={`url(#${gradientId})`}
      />
      <path
        opacity="0.07"
        d="M58.9277 42.7898L40.1059 23.967L32.0002 21.7979L24.7194 24.5039L21.9077 31.8294L24.1685 39.9858L44.1282 59.9456L48.3637 59.7574L58.9277 42.7898Z"
        fill="black"
      />
      <path
        d="M32.0002 20.52C25.7545 20.52 20.6912 25.5833 20.6912 31.8294C20.6912 38.0751 25.7545 43.1384 32.0002 43.1384C38.2458 43.1384 43.3087 38.0751 43.3087 31.8294C43.3087 25.5833 38.2453 20.52 32.0002 20.52ZM32.0002 40.41C27.2611 40.41 23.4191 36.568 23.4191 31.829C23.4191 27.0899 27.2611 23.2484 32.0002 23.2484C36.7393 23.2484 40.5812 27.0904 40.5812 31.8294C40.5812 36.5685 36.7393 40.41 32.0002 40.41Z"
        fill="white"
      />
      <path
        d="M26.6321 31.3926V34.9079C27.1523 35.8008 27.8861 36.5506 28.7676 37.0897V31.3926H26.6321ZM30.8666 28.4292V37.8932C31.2298 37.96 31.6014 38.0005 31.9831 38.0005C32.3312 38.0005 32.6706 37.9639 33.0036 37.9084V28.4292H30.8666ZM35.299 32.8533V37.0278C36.1946 36.4583 36.93 35.6695 37.4355 34.7363V32.8538L35.299 32.8533ZM40.1381 38.7952L38.9664 39.9678C38.8672 40.0673 38.8115 40.202 38.8115 40.3425C38.8115 40.483 38.8672 40.6177 38.9664 40.7172L43.4106 45.1598C43.51 45.2591 43.6448 45.3148 43.7852 45.3148C43.9257 45.3148 44.0605 45.2591 44.1599 45.1598L45.3315 43.9887C45.4302 43.889 45.4855 43.7545 45.4855 43.6143C45.4855 43.4741 45.4302 43.3395 45.3315 43.2398L40.8869 38.7952C40.7874 38.6964 40.6528 38.6409 40.5125 38.6409C40.3722 38.6409 40.2376 38.6964 40.1381 38.7952Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="32.0002"
          y1="4.05508"
          x2="32.0002"
          y2="59.5175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4387FD" />
          <stop offset="1" stopColor="#4683EA" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
